<div class="grid-x full-width">
  <div class="cell small-9">
    <h2 class="h3 bold">{{title}}</h2>
  </div>
  <div class="cell small-3">
    @if (enableSort) {
      <span class="padding-right-small">
        <button (click)="setMode(modes.Sort)" [ngClass]="{'active-option' : mode === modes.Sort }">
          <svg-icon icon="icon-up-down-drag" [hoverText]="'Sort'" class="tiny black"></svg-icon>
        </button>
      </span>
    }
    @if (enableSearch) {
      <span class="padding-right-small">
        <button (click)="setMode(modes.Search)" [ngClass]="{'active-option' : mode === modes.Search }">
          <svg-icon icon="icon-data-lookup" class="tiny black" [hoverText]="'Search'"></svg-icon>
        </button>
      </span>
    }
    @if (enableFilter) {
      <span>
        <button (click)="setMode(modes.Filter)" [ngClass]="{'active-option' : mode === modes.Filter }">
          <svg-icon icon="icon-view" class="tiny black" [hoverText]="'Filter'"></svg-icon>
        </button>
      </span>
    }
  </div>
  @switch (mode) {
    @case (modes.Sort) {
      <div class="cell small-2">
        <button (click)="setSortDirection(directions.Ascending)">
          <svg-icon icon="icon-caret-up" class="small black" [ngClass]="{ 'light-blue': currentSortArgs.sortDirection === directions.Ascending }"></svg-icon>
        </button>
        <button (click)="setSortDirection(directions.Descending)">
          <svg-icon icon="icon-caret-down" class="small black" [ngClass]="{ 'light-blue': currentSortArgs.sortDirection === directions.Descending }"></svg-icon>
        </button>
      </div>
      <div class="cell small-10">
        <select (ngModelChange)="sortOptionChanged($event)" [(ngModel)]="selectedSort">
          @for (option of sortItems; track option) {
            <option [value]="option.value">{{option.display}}</option>
          }
        </select>
      </div>
    }
    @case (modes.Filter) {
      <div class="cell small-10">
        <input type="text" placeholder="Filter Term" [(ngModel)]="filterText" (ngModelChange)="filter()" />
      </div>
      <div class="cell small-2">
        <span class="padding-left">
          <button (click)="resetFilter()">
            <svg-icon icon="icon-reply" class="tiny black" [hoverText]="'Clear'"></svg-icon>
          </button>
        </span>
      </div>
    }
    @case (modes.Search) {
      <div class="cell small-10 padding-right-small">
        <input type="text" placeholder="Search Term" [(ngModel)]="searchTerm" />
      </div>
      <div class="cell small-2">
        <span class="padding-left-small padding-right-small">
          <button (click)="search()">
            <svg-icon icon="icon-play" class="tiny black" [hoverText]="'Search'"></svg-icon>
          </button>
        </span>
        <span class="padding-left-small">
          <button (click)="resetSearch()">
            <svg-icon icon="icon-reply" class="tiny black" [hoverText]="'Clear'"></svg-icon>
          </button>
        </span>
      </div>
    }
    @default {
      &nbsp;
    }
  }
</div>

